import { Map } from "immutable"

import { defaultAllTopicTypes } from "../../config/application-definitions"
import {
    STUDIO_LIST_REQUEST as LIST_REQUEST,
    STUDIO_LIST_RESPONSE as LIST_RESPONSE,
    STUDIO_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    STUDIO_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    STUDIO_ITEM_DELETE_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

const defaultSearchCriteria = Map({
    name: "",
    types: defaultAllTopicTypes.map(({ name }) => name),
    statuses: "Active"
})

const defaultReducer = buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)

export default (state = undefined, action) => {
    const defaultReduction = defaultReducer(state, action)
    const { type, id } = action
    switch (type) {
        case STUDIO_ITEM_DELETE_RESPONSE:
            return Object.keys(defaultReduction)
                .filter(key => {
                    const value = defaultReduction[key]
                    return value.data && value.data.some(storedId => id)
                })
                .reduce(
                    (currentState, key) => ({
                        ...currentState,
                        [key]: {
                            ...defaultReduction[key],
                            isInvalidating: true
                        }
                    }),
                    defaultReduction
                )
        default:
            return defaultReduction
    }
}
